import { get, post, put, deleteUrl, postUrl } from './index'

import base from './base'

const official = base + 'inclusion-official/'
const system = base + 'inclusion-system/'
const solr = base + 'inclusion-solr/'

export default {
    getZdType: (type) => { // 用type获取字典
        return get(system + 'dict/queryListByType/' + type)
    },
    getZdCode: (code) => { // 用code获取字典
        return get(system + 'dict/queryListByType/' + code)
    },
    getJson: (code, fn) => { // 获取JSON串
        return get(system + 'setting/getByCode/' + code).then(res => {
            fn(res && res.data && res.data.content ? JSON.parse(res.data.content) : '')
        })
    },

    guestList: () => { // 查询官网web前端首页嘉宾
        return get(official + 'webHome/guestList')
    },
    trendsList: (data) => { // 查询官网web前端首页大会动态资讯
        return post(official + 'webHome/trendsList', data)
    },
    exhibitionPhotosList: (data) => { // 查询官网web前端科技展览直击现场图片
        return post(official + 'webForum/exhibitionPhotosList', data)
    },
    exhibitionDetail: () => { // 查询官网web前端科技展览详情
        return get(official + 'webForum/exhibitionDetail')
    },
    webSpecialActivitiesList: () => { // 查询官网web前端特色活动
        return get(official + 'webSpecialActivities/list')
    },
    greenFairDetail: (uuid) => { // 查询官网web前端特色活动 绿色集市详情
        return get(official + `webSpecialActivities/greenFairDetail/${uuid}`)
    },
    jobFairDetail: (uuid) => { // 查询官网web前端特色活动 科技招聘会详情
        return get(official + `webSpecialActivities/jobFairDetail/${uuid}`)
    },
    sponsorList: () => { // 查询官网web前端赞助商合作伙伴 赞助商列表
        return get(official + `webSponsorPartners/sponsorList`)
    },
    sponsorDetail: (uuid) => { // 查询官网web前端赞助商合作伙伴 赞助商详情
        return get(official + `webSponsorPartners/sponsorDetail/${uuid}`)
    },
    partnersList: () => { // 查询官网web前端赞助商合作伙伴 合作伙伴列表
        return get(official + `webSponsorPartners/partnersList`)
    },
    partnersDetail: (uuid) => { // 查询官网web前端赞助商合作伙伴 合作伙伴详情
        return get(official + `webSponsorPartners/partnersDetail/${uuid}`)
    },
    newsList: (data) => { // 查询官网web前端媒体新闻列表
        return post(official + 'webMedia/newsList', data)
    },
    insightsTrendsList: (data) => { // 查询官网web前端媒体见解趋势列表
        return post(official + 'webMedia/insightsTrendsList', data)
    },
    videoList: (data) => { // 查询官网web前端媒体大会视频列表
        return post(official + 'webMedia/videoList', data)
    },
    newsDetail: (uuid) => { // 查询官网web前端媒体新闻详情
        return get(official + `webMedia/newsDetail/${uuid}`)
    },
    insightsTrendsDetail: (uuid) => { // 官网web前端媒体见解趋势详情
        return get(official + `webMedia/insightsTrendsDetail/${uuid}`)
    },
    videoDetail: (uuid) => { // 官网web前端媒体大会视频详情
        return get(official + `webMedia/videoDetail/${uuid}`)
    },
    listTab: () => { // 查询官网web前端论坛列表tab
        return get(official + `webForum/listTab`)
    },
    webForumList: (data) => { // 查询官网web前端论坛列表
        return post(official + 'webForum/list', data)
    },
    webForumDetail: (uuid) => { // 查询官网web前端论坛详情
        return get(official + `webForum/detail/${uuid}`)
    },
    mainDetail: () => { // 查询官网web前端主论坛详情
        return get(official + `webForum/mainDetail`)
    },
    photosList: (data) => { // 查询官网web前端论坛直击现场图片
        return post(official + 'webForum/photosList', data)
    },
    webApplyAdd: (data) => { // 新增参会申请
        return post(official + 'webApply/add', data)
    },
    agendaList: (data) => { // 查询官网web前端日程
        return post(official + 'webForum/agendaList', data)
    },
    liveList: (data) => { // 查询官网web前端直播列表
        return post(official + 'webLive/liveList', data)
    },
    momentsList: (data) => { // 查询官网web前端精彩瞬间列表
        return post(official + 'webLive/momentsList', data)
    },
}



// WEBPACK FOOTER //
// ./src/api/protal.js